import { render, staticRenderFns } from "./temp-slice.vue?vue&type=template&id=23145139&scoped=true"
import script from "./temp-slice.vue?vue&type=script&lang=js"
export * from "./temp-slice.vue?vue&type=script&lang=js"
import style0 from "./temp-slice.vue?vue&type=style&index=0&id=23145139&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23145139",
  null
  
)

export default component.exports